import { Component, OnInit, OnDestroy } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { AccountService } from '../account.service';
import { UpdatePassword } from '../UpdatePassword';
import { AccountResponse } from '../model/account';
import { TranslateService } from '@ngx-translate/core';
import { passwordValidator } from '../passwordValidator';
import { LicenseContent } from '../../license/licenseContent';
import { LicenseSelectingFunction } from '../../license/licenseSelectingFunction';
import { ProgressSpinnerMode } from 'ng-uikit-pro-standard/lib/pro/progressbars/progress-spinner-module';
import { Localization } from '../../shared/enums/localization';
import { Account } from '../../accounts/model/account';
import { AccountError } from '../model/accountError';

@Component({
  selector: 'app-account-confirm',
  templateUrl: './account-confirm.component.html',
  styleUrls: ['./account-confirm.component.scss'],
  providers: [AccountService]
})
export class AccountConfirmComponent implements OnInit, OnDestroy {

  public accountConfirmGroup: FormGroup;
  public licenseContent = '';
  public sub: any;
  public culture: any;
  public confirmationCode: string;
  public account: Account;
  public progressSpinnerMode: ProgressSpinnerMode = 'indeterminate';
  public showSpinner = true;
  public translationCompleted = false;
  public agreedToTerms: boolean;
  public newPasswordRequired = false;
  public readonly Localization = Localization;

  constructor(
    private formBuilder: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private accountService: AccountService,
    private translate: TranslateService,
    ) {
    this.licenseContent = LicenseContent.licenseContent;
  }

  ngOnInit() {
    this.agreedToTerms = false;
    this.sub = this.route.params.subscribe(params => {
      this.culture = params['culture'] || 'en-US';
      this.confirmationCode = params['confirmationCode'];

      this.translate.use(this.culture).subscribe(
        () => { },
        () => { },
        () => { this.translationCompleted = true; }
      );

      this.getLicenseByCulture();

      this.accountService.getLoginByConfirmationCodeAndConfirm(this.confirmationCode).subscribe(
        (response: AccountResponse) => {
          this.account = response.account;
          this.newPasswordRequired = response.newPasswordRequired;
          this.accountConfirmGroup.get('newPasswordRequired').setValue(response.newPasswordRequired);
          this.showSpinner = false;
        },
        err => {
          this.handleError(err.error);
        });
    });

    this.accountConfirmGroup = this.formBuilder.group({
      password: [],
      passwordConfirm: [],
      newPasswordRequired: [],
    }, { validator: passwordValidator });
  }

  public onAgreeToTermsChange(checked: boolean) {
    this.agreedToTerms = checked;
  }

  getLicenseByCulture() {
    this.licenseContent = LicenseSelectingFunction(this.culture);
  }

  onSubmit() {
    if (this.accountConfirmGroup.valid) {
      if (this.newPasswordRequired) {
        const updatePassword = new UpdatePassword(this.confirmationCode, this.accountConfirmGroup.get('password').value);
        this.accountService.updatePasswordAndAgreeLicense(updatePassword).subscribe(
          () => {
            this.router.navigateByUrl('/account-created');
          },
          err => {
            this.handleError(err.error);
          }
        );
      } else {
        this.accountService.agreeLicenseOnly(this.confirmationCode).subscribe(
          () => {
            this.router.navigateByUrl('/account-created');
          },
          err => {
            this.handleError(err.error);
          }
        );
      }
    }
  }

  handleError(error: string) {
    const errorCode = AccountError[error];

    if (errorCode != null && errorCode === AccountError.AccountAlreadyConfirmed) {
      this.router.navigateByUrl('/account-already-confirmed');
    } else {
      this.router.navigateByUrl('/account-error');
    }
  }

  ngOnDestroy() {
    this.sub.unsubscribe();
  }
}
